/*
 * File: CustomerIdFilter.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 21 Dec 2021 2:24:52 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setProjectNameContains } from 'redux/services/mrsGrouch/projectsParams';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../FancyInput';
export const ProjectNameFilter = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setProjectNameContains(ev.target.value));
  }, 300);

  useEffect(() => {
    return (): void => {
      dispatch(setProjectNameContains(undefined));
    };
  }, []);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small" style={{ marginLeft: 5, marginRight: 5 }}>
      <FancyInput onChange={handleInputChange} placeholder={'Customer Project Id'} width={185} />
    </Space>
  );
};
